export function wrapIndex<T>(index: number, array: T[]): T {
    if (!array || !array.length) {
        return null;
    }

    while (index < 0) {
        index += array.length;
    }
    while (index >= array.length) {
        index -= array.length;
    }

    const symbolId = array[index];

    return symbolId;
}

export function contains<T>(arr: T[], value: T): boolean {
    for (const v of arr) {
        if (v === value) {
            return true;
        }
    }
    return false;
}

export function unique<T>(arr: T[]) {
    const uniqueArr = [];
    for (const v of arr) {
        if (!contains(uniqueArr, v)) {
            uniqueArr.push(v);
        }
    }
    return uniqueArr;
}

/**
 * Removes any element which rejectArr contains from sourceArr
 * @param sourceArr {T[]}
 * @param rejectArr {T[]}
 */
export function reject<T>(sourceArr: T[], rejectArr: T[]) {
    const rejectedArr = [];
    for (const v of sourceArr) {
        if (!contains(rejectArr, v)) {
            rejectedArr.push(v);
        }
    }
    return rejectedArr;
}

/**
 * Pushes the same value to the array 'count' number of times
 * @param arr {T[]}
 * @param value {T}
 * @param count {number}
 */
export function addRepeated<T>(arr: T[], value: T, count: number) {
    while (count > 0) {
        count--;
        arr.push(value);
    }
}

export function clearMap<T>(map: Map<string, T>) {
    if (map) {
        map.forEach((obj: any) => {
            if (obj.destroy) {
                obj.destroy();
            }
        });

        map.clear();
    }
}

export function lowerCaseMapKeys(map: Map<string, any>) {
    map.forEach((value: any, key: string) => {
        map.set(key.toLowerCase(), map.get(key));
    });
}

export function lowerCaseMapValues(map: Map<any, string>) {
    map.forEach((value: string, key: any) => {
        map.set(key, map.get(key).toLowerCase());
    });
}

export function shuffle<T>(a: T[]) {
    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
}



// WEBPACK FOOTER //
// ./~/slotworks/utils/collection-utils.ts